import { Accordion } from 'primereact/accordion'; // Importing PrimeReact's Accordion components
import { PrimeReactProvider } from 'primereact/api';
import React from 'react';
import { classNames } from 'primereact/utils';
import { twMerge } from 'tailwind-merge';

export enum AccordionHeaderType {
  BORDER_BOTTOM = 'filled',
  OUTLINED = 'outlined',
  NO_BORDER = 'no-border',
}

export interface IAccordionProps {
  children: React.ReactNode;
  multiple?: boolean;
  type?: AccordionHeaderType;
}

export const LiliAccordion = ({ children, multiple, type }: IAccordionProps) => {
  const Tailwind = {
    accordion: {
      root: {
        // can insert attr to root here
      },
      accordiontab: {
        root: () => {
          const baseClasses = 'mb-[12px] gap-[8px] bg-inherit';
          let typeClasses = '';
          switch (type) {
            case AccordionHeaderType.BORDER_BOTTOM:
              typeClasses = 'border-bw03 border-b';
              break;
            case AccordionHeaderType.OUTLINED:
              typeClasses = 'border-bw04 border';
              break;
            case AccordionHeaderType.NO_BORDER:
              typeClasses = '';
              break;
            default:
              typeClasses = '';
          }
          return {
            className: twMerge(baseClasses, typeClasses),
          };
        },
        header: ({ props }: { props: { disabled: boolean } }) => ({
          className: classNames(
            { 'select-none pointer-events-none cursor-default  opacity-60': props?.disabled }, // Condition
          ),
        }),
        headerAction: ({ context }: { context: { selected: boolean } }) => ({
          className: classNames(
            'flex flex-row-reverse bg-inherit flex-row items-center justify-end pr-4 cursor-pointer relative no-underline select-none', // Alignments
            'p-1 pl-0 transition duration-200 ease-in-out rounded-t-md font-bold transition-shadow duration-200', // Padding and transition
            'border-radius: 8px',
            {
              'rounded-br-md rounded-bl-md flex-row border:0px': !context.selected,
              'rounded-br-0 rounded-bl-0 text-gray-800': context.selected,
            },
          ),
        }),
        headericon: ({ context }: { context: { selected: boolean } }) => ({
          className: `relative ml-[8px] text-[#0E5CF4] rotate-90 transition-transform duration-300 ${
            context.selected ? 'rotate-180' : 'rotate-90'
          }`,
        }),

        toggleableContent: () => ({
          className: 'pb-0 bg-inherit',
        }),
        content: {
          className: 'p-[5px] pl-0 bg-inherit ',
        },
        transition: {
          toggleable: {
            timeOut: 500,
            classNames: {
              exitActive: '!max-h-0 overflow-hidden transition-[max-height] duration-300 ease-out border-t-0 p-0 ',
              exit: 'max-h-[1000px] ',
            },
          },
        },
      },
    },
  };

  return (
    <PrimeReactProvider value={{ pt: Tailwind }}>
      <Accordion multiple={multiple}>{children}</Accordion>
    </PrimeReactProvider>
  );
};

export interface IAccordionTabProps {
  Header: React.ElementType;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {}>;
  id?: string;
}

export const AccordionTabHeaderTemplate = ({ Header, Icon, id }: IAccordionTabProps) => (
  <div id={id || ''} className='h-[56px] w-[402px] p-2  rounded-lg flex justify-between items-center'>
    <div className='flex items-center gap-2'>
      {Icon && <Icon className='w-[38px] h-[38px]' />}
      <Header />
    </div>
  </div>
);
export const AccordionTabHeaderTemplateOneLiner = ({ Header, Icon, id }: IAccordionTabProps) => (
  <div id={id || ''} className='h-fit w-fit rounded-lg flex justify-between items-center'>
    <div className='flex items-center gap-2'>
      {Icon && <Icon className='w-[38px] h-[38px]' />}
      <Header />
    </div>
  </div>
);
